import { Switch } from "components/Graphs/Switch";
import React from "react";

interface InstallJupyterOnHostToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  id?: string;
}

export const InstallJupyterOnHostToggle: React.FC<
  InstallJupyterOnHostToggleProps
> = ({ checked, onCheckedChange, id = "jupyter-enabled" }) => (
  <div className="mb-6">
    <h3 className="text-base font-medium text-white">Jupyter</h3>
    <p className="mt-1 text-sm text-secondary">
      Installs Jupyter on the VM and makes it available on port 8888.
    </p>
    <div className="mt-3 flex flex-row items-center text-sm text-secondary">
      <Switch
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        className="mr-2"
      />
      <label htmlFor={id} className="text-primary">
        Install Jupyter on the host
      </label>
    </div>
  </div>
);
